var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.8318 0 0 5.83188 0 13.0001C0 20.1683 5.8318 26 13 26C20.1682 26 26 20.1683 26 13.0001C26 5.83188 20.1682 0 13 0ZM13 23.6364C7.13503 23.6364 2.36364 18.865 2.36364 13.0001C2.36364 7.13519 7.13503 2.36364 13 2.36364C18.865 2.36364 23.6364 7.13519 23.6364 13.0001C23.6364 18.865 18.8649 23.6364 13 23.6364Z",
    fill: "#1A5268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 5.51514C12.1311 5.51514 11.4244 6.22234 11.4244 7.0916C11.4244 7.96008 12.1311 8.66665 12.9999 8.66665C13.8686 8.66665 14.5753 7.96008 14.5753 7.0916C14.5753 6.22234 13.8686 5.51514 12.9999 5.51514Z",
    fill: "#1A5268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.0303C12.3473 11.0303 11.8182 11.5594 11.8182 12.2121V19.303C11.8182 19.9557 12.3473 20.4848 13 20.4848C13.6527 20.4848 14.1818 19.9557 14.1818 19.303V12.2121C14.1818 11.5594 13.6527 11.0303 13 11.0303Z",
    fill: "#1A5268"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5703523c3d6c746f8c2da48bdd757821.svg";
export { ForwardRef as ReactComponent };